
import _LabelInputBase from '../_LabelInputBase/_LabelInputBase';
import _InputMultiBase from '../_InputMultiBase/_InputMultiBase';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DatePicker.html?raw';
import on from 'dojo/on';
import docu from './DatePickerDocumentation.html?raw';
import Tooltip from '../Floating/Tooltip';
import { ColorHelpers, DateHelpers, HtmlHelpers } from "../../../more/Helpers";
import FloatingContainer from '../Floating/FloatingContainer';


interface DatePickerIconEntry {
    groupValue: string;
    count: number;
    description?: string | Array<string>;
    tooltipWidget?: any;
    node: HTMLElement;
    shortDate: string;
    //label: string;
    labelNode: HTMLElement;
}

interface DatePickerAppointmentData {
    groupValue: string;
    date: Date;
    iconOrNode: any;
    title: string;
    clickFct: Function;
    colorationHex?: string;
}

interface HolidayData {
    node: HTMLElement;
    date: Date;
    icon: string;
    title: string;
    hexColorBG?: string;
    hexColorTXT?: string;
    content?: string | HTMLElement;

}

interface DatePickerIconContainer {
    node: HTMLElement,
    icons: Array<DatePickerIconEntry>
}
class DatePicker extends compose(_InputMultiBase, _LabelInputBase) {
    templateString: any = template;

    callback: Function = function () { };

    //--inherited--
    //multiselect: boolean = false;
    //selectedDates: Array<string> = new Array<string>();
    //inputWidget: object = null;

    private navigationDate: Date;
    private _showState: boolean = true;
    //allowPast: boolean = true;
    private enableUnselect: boolean = false; // ist nur true für Navigations-Modus (Agendaview)
    private displayAppointmentIcons: boolean = false; // für Agendaview
    private enableSelect: boolean = true; // für Modi wo nur geblättert werden soll gibt es keine "Auswahl"
    earliestDate: Date = null;
    latestDate: Date = null;
    _lastCreatedDate: Date;

    private earliestYear: number;
    private latestYear: number;
    private earliestMonth: Date;
    private latestMonth: Date;
    private visibleFirstDate: Date;
    private visibleLastDate: Date;

    private earliestSelectedDate: Date; // TODO: für Intervall-Auswahl....
    private latestSelectedDate: Date;

    //private yearsBack: number = 2;
    //private yearsForward: number = 2;

    closeAfterSelection: boolean = false;

    //classNameToday: string = "today";
    //classNameSelected: string = "selected";
    //classNameOthermonth: string = "othermonth";
    //classNameWeekend: string = "weekend";

    //classNameButton: string = "mds-button-base round hoverDark";
    //classNameDefault: string = "default";

    private yearSelectPopup: HTMLElement;
    private monthSelectPopup: HTMLElement;
    private yearSelectButton: HTMLElement;
    private monthSelectButton: HTMLElement;

    private menuContainer: HTMLElement;
    private tableContainer: HTMLElement;

    private showAppointmentLabels: boolean = false;

    private nodeList: Record<string, {
        dayContainer: HTMLElement,
        dayLabelNode: HTMLElement,
        appointmentsNode: HTMLElement,
        iconContainer: DatePickerIconContainer,
        holidays: Array<HolidayData>
    }>;
    //private iconContainers: Array<DatePickerIconContainer>;

    getValue(): Date {
        // wenn Selektierung eines Datums nicht möglich: das Navigationsdatum ausgeben
        if (!this.enableSelect) {
            return this.navigationDate;
        }

        for (let dateStr in this.currentSelect) {
            return new Date(dateStr);
        }

        return null;
    }


    //let it be if you wnat to get Date Obj, parent class getValue will return strings
    //which are stored in the currentSelect array

    getValues(): Array<Date> {
        let dates = new Array<Date>();
        for (let dateStr in this.currentSelect) {
            dates.push(new Date(dateStr));
        }
        return dates;
    }

    getFirstVisibleDate(): Date {
        return this.visibleFirstDate;
    }

    getLastVisibleDate(): Date {
        return this.visibleLastDate;
    }

    // overloaded because of _create calendar
    setValue(value: Date) {
        
        this.removeCurrentSelect();

        if (!this.enableSelect) return;
        if (value) {
            this.toggleDateSelect(value)
        } else {
            this._drawCalendar(this.navigationDate);
        }

         
    }

    setValues(values: Array<Date>) {

        this.removeCurrentSelect();

        if (!this.enableSelect) return;

        if (values.length > 0) {
            for (var i = 0; i < values.length; i++) {
                this.addSelect(this.getShortDate(values[i]));
            }

            this._drawCalendar(values[0]);
        }
    }

    setMultiselect(value: boolean): void {
        if (!this.enableSelect) return;

        this.removeCurrentSelect();
        this.isMultiSelect = value;
        this._drawCalendar(this._lastCreatedDate);
    }



    _setCallbackAttr(value: Function): void {
        this.callback = value;
    }

    _setCloseAfterSelectAttr(value): void {
        this.closeAfterSelection = value === true;
    }

    private _closeDropwdowns(): void {
        if (this.monthSelectPopup.classList.contains("show")) this.toggleMonthSelect();
        if (this.yearSelectPopup.classList.contains("show")) this.toggleYearSelect();
    }

    private _changePage(e: Event): void {
        var targ = e.target as HTMLElement;

        this.emptyAppointments();

        if (!this.UiModder.domAttr.has(targ, "date")) {
            targ = targ.parentNode as HTMLElement;;
        }
        if (targ.getAttribute('date') != null) {
            let targetDate = new Date(targ.getAttribute('date'));
            targetDate.setDate(1);
            targetDate.setMinutes(0, 0, 0);
            this.knownAppointments = [];
            this._drawCalendar(targetDate);
            this.emit("pageChange", targetDate);

        }

        e.stopPropagation();
    }

    private _onClick_Day(targetDateTxt: string, e?: MouseEvent) {
        let value = null;
        if (targetDateTxt) {
            value = new Date(targetDateTxt);
        }
        this.toggleDateSelect(value);
    }

    private toggleDateSelect(targetDate: Date): void {
        //var targ = e.target as HTMLElement;
        //var d = targ.getAttribute('date');
        //this.selectedDate = targetDate;
        let targetDateTxtShort = this.getShortDate(targetDate);
        
        // schon selektiert?
        for (let selectedDate of this.getValues()) {
            if (targetDateTxtShort == this.getShortDate(selectedDate)) {
                if (this.enableUnselect) {
                    this.removeCurrentSelect();
                    this._drawCalendar();
                    this.emit("change", this.getValues());
                    return;
                } else {
                    return;
                }
            }
        }

        if (!this.enableSelect) return;
        
        if (this.isMultiSelect) {
            if (this.currentSelect[targetDateTxtShort]) {
                this.removeSelect(targetDate.toString());
            } else {
                this.addSelect(targetDateTxtShort);
            }
            this._drawCalendar(targetDate);
            this.emit("change", this.getValues());
        } else {
            this.removeCurrentSelect();
            this.addSelect(targetDateTxtShort);

            if (this.closeAfterSelection == true) {
                this.hide();
            }
            this.emit("change", this.getValues());
        }

    }

    //--inherited--

    //addDate(d): void {
    //    this.currentSelect[d] = d;
    //    this._closeDropwdowns();

    //    if (this.nodeList[d]) this.changeItemState(this.nodeList[d], "selected");

    //    if (typeof this.callback === "function") {
    //        this.callback("add", d, this.currentSelect);
    //    }
    //}

    //removeDate(d) {
    //    if (this.currentSelect[d]) {
    //        this._closeDropwdowns();
    //        delete this.currentSelect[d];
    //        if (this.nodeList[d]) this.changeItemState(this.nodeList[d]);
    //    }

    //    if (typeof this.callback === "function") {
    //        this.callback("del", d, this.currentSelect);
    //    }
    //}

    //removeSelectedDates(): void {
    //    for (var d in this.currentSelect) {
    //        this.removeDate(d);
    //    }
    //    this._closeDropwdowns();
    //    //this.hide();
    //}

    //getMultiselect(): boolean {
    //    return this.isMultiSelect;
    //}

    ////////////////////////////////
    // Overlaoded

    protected addSelectLocal(nodeIndex): void {
        this._closeDropwdowns();

        let reg = this.nodeList[nodeIndex];
        if (!reg) return;

        if (reg.dayContainer) this.UiModder.domClass.add(reg.dayContainer, "selected");

        if (typeof this.callback === "function") {
            this.callback("add", nodeIndex, this.currentSelect);
        }

        if (!this.isMultiSelect) {
            this._drawCalendar(this.getValue());
        }


    }

    removeCurrentSelectLocal(): void {
        this._closeDropwdowns();
    }

    removeSelect(dateTxt: string) {
        if (this.currentSelect[dateTxt]) {
            this._closeDropwdowns();
            delete this.currentSelect[dateTxt];
            let reg = this.nodeList[dateTxt];
            if (!reg) return;

            if (reg.dayContainer) this.UiModder.domClass.remove(reg.dayContainer, "selected");
        }

        if (typeof this.callback === "function") {
            this.callback("del", dateTxt, this.currentSelect);
        }
    }
    ////////////////////////////////////



    getShortDate(d: Date): string {
        if ((typeof d == 'undefined') || (d == null)){
            console.warn("getShortDate is undefined", d);
            return "N/A";
        }
        let result = DateHelpers.dateToString(d, "yyyy-MM-dd");
        return result;
        //return ("0" + d.getDate()).slice(-2) + '.' + ("0" + (d.getMonth() + 1)).slice(-2) + '.' + d.getFullYear();
    }

    getMonth(d): any {
        return d.toLocaleDateString(window.currentLanguageCode2, { month: "long" });
        //return ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'][d.getMonth()];
    }


    getDisplayedMonth(): Date {
        return this.navigationDate;
    }


    private _redrawNavigation(targetDate?: Date) {

        if (!targetDate) {
            targetDate = this.navigationDate;
        }

        if (!targetDate) return;
        
        let targetMonthDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), 1, 0, 0, 0, 0);
        this.navigationDate = targetMonthDate;
        this.UiModder.domConstruct.empty(this.menuContainer);

        let menuContainer = this.menuContainer;
        let today = new Date();

        let earliestDate = this.earliestDate;
        let earliestMonth = this.earliestMonth;
        let earliestYear = this.earliestYear;
        let latestDate = this.latestDate;
        let latestMonth = this.latestMonth;
        let latestYear = this.latestYear;


        let prevMonthButton = this.UiModder.domConstruct.create("button", {
            //type: "button",
            id: "previousMonthButton",
            className: "buttonBase round",
            innerHTML: "<i class=\"fas fa-chevron-left\" aria-hidden=\"true\"></i>"
        }, menuContainer, "last");
        this.setDataCyAttribute(prevMonthButton, "prev-month");

        // prüfen ob wir damit nicht eh zu weit nach hinten blättern würden!

        let prevMonthdate = new Date(targetDate.getFullYear(), targetDate.getMonth() - 1, 1, 0, 0, 0, 0);

        if (earliestMonth && prevMonthdate.getTime() < earliestMonth.getTime()) {
            this.UiModder.domClass.add(prevMonthButton, "w3-disabled");

        } else {
            this.UiModder.domAttr.set(prevMonthButton, "date", prevMonthdate);
            on(prevMonthButton, "click", lang.hitch(this, this._changePage));

            this.UiModder.domClass.add(prevMonthButton, "hoverDark");
        }

        let middleSection = this.UiModder.domConstruct.create("div", {
            id: "navMidsection",
            class: "flex_row flex_cell_rest"
        }, menuContainer);


        let monthSelectButton = this.UiModder.domConstruct.create("button", {
            //type: "text",
            readonly: true,
            className: "monthButton buttonBase hoverDark flex_cell_rest",
            id: "monthMenuButton",
            innerHTML: this.getMonth(targetDate)
        }, middleSection, "last");

        on(monthSelectButton, "click", lang.hitch(this, this.toggleMonthSelect));
        this.monthSelectButton = monthSelectButton;
        this.setDataCyAttribute(monthSelectButton, "month-select");

        this.monthSelectPopup = this.UiModder.domConstruct.create("div", {
            style: "",
            id: "monthselectorPopup",
            className: "w3-card w3-border bg2"
        }, monthSelectButton, "last");
        on(this.monthSelectPopup, "click", lang.hitch(this, this._changePage));
        for (var i = 1; i < 13; i++) {
            let month = new Date(targetDate.getFullYear(), i, 0, 0, 0, 0);

            let monthButton = this.UiModder.domConstruct.create("button", {
                "className": "monthSelect",
                innerHTML: this.getMonth(month),
            }, this.monthSelectPopup, "last");
            this.setDataCyAttribute(monthButton, "month:" + i);
            if (month.getMonth() == today.getMonth() && targetDate.getFullYear() == today.getFullYear()) {
                this.UiModder.domClass.add(monthButton, "current");
            }

            let selectable = true;
            if (earliestMonth && month.getTime() < earliestMonth.getTime()) {
                selectable = false;
            }
            if (latestMonth && month.getTime() > latestMonth.getTime()) {
                selectable = false;
            }

            if (!selectable) {
                this.UiModder.domClass.add(monthButton, "w3-disabled");
            }
            else {
                this.UiModder.domAttr.set(monthButton, "date", month.toString());
            }

            // Unterscheiden: welches Datum ist denn tatsächlich ausgewählt und was ist nur aktuell durchs Umschalten unser Navigationsziel?
            // das gewählte Navigationsziel markieren:
            if (month.getMonth() == targetDate.getMonth() && month.getFullYear() == targetDate.getFullYear()) {
                this.UiModder.domClass.add(monthButton, "selected");
            }
            else {
                this.UiModder.domClass.add(monthButton, "hoverDark");
            }

            // das GEWÄHLTE Datum bekommt noch eine separate STyleklasse
            let selectedDates = this.getValues();
            for (let selectedDate of selectedDates) {
                if (typeof selectedDate != 'undefined'){
                    if (selectedDate != null){
                        if (month.getMonth() == selectedDate.getMonth() && month.getFullYear() == selectedDate.getFullYear()) {
                            this.UiModder.domClass.add(monthButton, "currentvalue");
                            break;
                        }
                    }
                }
            }
        }

        let yearSelectButton = this.UiModder.domConstruct.create("button", {
            //type: "text",
            readonly: true,
            id: "yearMenuButton",
            class: "yearButton buttonBase hoverDark flex_cell_rest",
            style: "",
            innerHTML: targetDate.getFullYear()
        }, middleSection, "last");

        on(yearSelectButton, "click", lang.hitch(this, this.toggleYearSelect));
        this.yearSelectButton = yearSelectButton;
        this.setDataCyAttribute(yearSelectButton, "year-select");


        this.yearSelectPopup = this.UiModder.domConstruct.create("div", {
            style: "",
            id: "yearselectorPopup",
            className: "w3-card w3-border bg2"
        }, yearSelectButton, "last");
        on(this.yearSelectPopup, "click", lang.hitch(this, this._changePage));
        let currentYear = earliestYear;
        while (currentYear <= latestYear) {
            let yearDate = new Date(currentYear, targetDate.getMonth(), targetDate.getDate(), 0, 0, 0, 0);
            if (yearDate.getTime() < earliestDate.getTime()) {
                yearDate = earliestDate;
            }
            if (yearDate.getTime() > latestDate.getTime()) {
                yearDate = latestDate;
            }


            let yearButton = this.UiModder.domConstruct.create("button", {
                innerHTML: yearDate.getFullYear(),
                "className": "yearSelect"
            }, this.yearSelectPopup, "last");
            this.setDataCyAttribute(yearButton, "year:" + yearDate.getFullYear());
            this.UiModder.domAttr.set(yearButton, "date", yearDate.toString());
            if (yearDate.getFullYear() == today.getFullYear()) {
                this.UiModder.domClass.add(yearButton, "current");
            }

            let selectedDates = this.getValues();
            
            for (let selectedDate of selectedDates) {
                if (typeof selectedDate != 'undefined'){
                    if (selectedDate != null){
                        if (selectedDate.getFullYear() == yearDate.getFullYear()) {
                            this.UiModder.domClass.add(yearButton, "currentvalue");
                            break;
                        }
                    }
                }
            }

            if (yearDate.getFullYear() == this.navigationDate.getFullYear()) {
                this.UiModder.domClass.add(yearButton, "selected");
            }
            
            else {
                this.UiModder.domClass.add(yearButton, "hoverDark");
            }

            currentYear++;
        }

        let nextMonthButton = this.UiModder.domConstruct.create("button", {
            //type: "button",
            className: "buttonBase",
            id: "nextMonthButton",
            innerHTML: "<i class=\"fas fa-chevron-right\" aria-hidden=\"true\"></i>"
        }, menuContainer, "last");
        this.setDataCyAttribute(nextMonthButton, "next-month");

        // prüfen ob wir damit nicht eh zu weit nach hinten blättern würden!

        let nextMonthDate = new Date(targetDate.getFullYear(), targetDate.getMonth() + 1, 1, 0, 0, 0, 0);

        if (latestMonth && nextMonthDate.getTime() > latestMonth.getTime()) {
            this.UiModder.domClass.add(nextMonthButton, "w3-disabled");

        } else {
            this.UiModder.domAttr.set(nextMonthButton, "date", nextMonthDate);
            on(nextMonthButton, "click", lang.hitch(this, this._changePage));

            this.UiModder.domClass.add(nextMonthButton, "hoverDark");
        }
    }


    private _drawCalendar(targetDate?: Date): Date {
        
        if (!targetDate) targetDate = this.navigationDate;
        if (targetDate == null) targetDate = new Date();

        this.UiModder.domClass.toggle(this.domNode, "showAppointmentLabels", this.showAppointmentLabels);

        // H:m:s,ms auf 0 setzen!
        targetDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), targetDate.getDate(), 0, 0, 0, 0);
        let earliestDate = new Date(targetDate.getFullYear() - 3, targetDate.getMonth(), targetDate.getDate(), 0, 0, 0, 0);
        let latestDate = new Date(targetDate.getFullYear() + 3, targetDate.getMonth(), targetDate.getDate(), 0, 0, 0, 0);
        let earliestMonth = new Date(earliestDate.getFullYear(), targetDate.getMonth(), 1, 0, 0, 0, 0);
        let latestMonth = new Date(latestDate.getFullYear(), targetDate.getMonth(), 1, 0, 0, 0, 0);;
        let earliestYear = earliestDate.getFullYear();
        let latestYear = latestDate.getFullYear();

        if (this.earliestDate) {
            earliestDate = this.earliestDate;
            earliestMonth = new Date(this.earliestDate.getFullYear(), this.earliestDate.getMonth(), 1, 0, 0, 0, 0);
            earliestYear = this.earliestDate.getFullYear();
        } 

        if (this.latestDate) {
            latestDate = this.latestDate;
            latestMonth = new Date(this.latestDate.getFullYear(), this.latestDate.getMonth(), 31, 0, 0, 0, 0);
            latestYear = this.latestDate.getFullYear();
        }

        this.earliestDate = earliestDate;
        this.earliestMonth = earliestMonth;
        this.earliestYear = earliestYear;
        this.latestDate = latestDate;
        this.latestMonth = latestMonth;
        this.latestYear = latestYear;
        


        if (earliestDate && targetDate.getTime() < earliestDate.getTime()) {
            targetDate = earliestDate;
        }

        if (latestDate && targetDate.getTime() > latestDate.getTime()) {
            targetDate = latestDate;
        }

        let todayShort = this.getShortDate(new Date());
        let visibleStartDate = new Date(targetDate.getFullYear(), targetDate.getMonth(), 1, 0, 0, 0, 0); // Starting at the 1st of the month
        let extras = (visibleStartDate.getDay() + 6) % 7; // How many days of the last month do we need to include?
        visibleStartDate.setDate(visibleStartDate.getDate() - extras); // Skip back to the previous monday

        this.visibleFirstDate = new Date(visibleStartDate.valueOf());

        let table: HTMLTableElement = this.UiModder.domConstruct.create("table") as HTMLTableElement;
        this.UiModder.domClass.add(table, "daytable agenda");
        var tr = this.UiModder.domConstruct.create("tr", null, table, "last");

        let menuTd = this.UiModder.domConstruct.create("td", {
            "colspan": "7",
            "className": "",
            "id": "menuHead"

        }, tr);


        this._redrawNavigation(targetDate);

        let daysRow = this.UiModder.domConstruct.create("tr", { className: "weekdaysRow"}, table, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 0).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header" }, daysRow, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 1).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header" }, daysRow, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 2).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header" }, daysRow, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 3).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header" }, daysRow, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 4).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header" }, daysRow, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 5).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header weekend" }, daysRow, "last");
        this.UiModder.domConstruct.create("td", { innerHTML: new Date(2019, 0, 6).toLocaleDateString(window.currentLanguageCode2, { weekday: "short" }), className: "header weekend" }, daysRow, "last");

        // bestehende Feiertage retten??
        let knownHolidays: HolidayData[] = [];
        for (let key in this.nodeList) {
            let reg = this.nodeList[key];
            for (let holiday of reg.holidays) {
                knownHolidays.push(holiday);
            }
        }

        this.nodeList = {};
        //this.iconContainers = [];

        let currentDate = visibleStartDate;
        while (1) { // Loop for each week
            let tr = table.insertRow(-1);
            for (let i = 0; i < 7; i++) {
                let currentDateTxt = this.getShortDate(currentDate);

                let calendarDayCell = this.UiModder.domConstruct.create("td", {
                    className: "daySelectorCell"
                }, tr, "last");

                let calendarDayContainer = this.UiModder.domConstruct.create("div", {
                    className: "daySelector",
                    innerHTML: "",
                }, calendarDayCell, "first");

                let dayLabel = this.UiModder.domConstruct.create("div", {
                    className: "daySelectorLabel",
                    innerHTML: ""
                }, calendarDayContainer);
                this.UiModder.domConstruct.create("span", {
                    className: "",
                    id: "dayNo",
                    innerHTML: currentDate.getDate()
                }, dayLabel);

                // iconkalender!
                let container = this.UiModder.domConstruct.create("div", {
                    className: "daySelectorIconContainer",
                    innerHTML: ""
                }, calendarDayContainer);

                let containerEntry: DatePickerIconContainer = {
                    icons: [],
                    node: container
                };
                this.nodeList[currentDateTxt] = {
                    dayLabelNode: dayLabel,
                    iconContainer: containerEntry,
                    appointmentsNode: container,
                    dayContainer: calendarDayContainer,
                    holidays: []
                };
                //this.iconContainers[currentDateTxt] = containerEntry;

                if (currentDate.getMonth() == targetDate.getMonth()) {

                    let selectable = true;
                    if (currentDate.getTime() < earliestDate.getTime()) {
                        selectable = false;
                    }
                    if (currentDate.getTime() > latestDate.getTime()) {
                        selectable = false;
                    }

                    this.UiModder.domClass.toggle(calendarDayContainer, "selectable hoverDark", selectable == true);
                    if (selectable == true) {
                        on(calendarDayContainer, "click", lang.hitch(this, this._onClick_Day, currentDate.toString()));
                        
                    }

                    
                    else {
                        this.UiModder.domClass.add(calendarDayContainer, "inactive");
                    }

                } else {
                    this.UiModder.domClass.toggle(calendarDayContainer, "inactive othermonth", true);
                }

                this.UiModder.domAttr.set(calendarDayContainer, "date", currentDateTxt);
                // stabiles data-cy je Tag (ISO YYYY-MM-DD) fuer E2E-Tests (daypick-Step);
                // ueber die geerbte _ControlBase.setDataCyAttribute. Praefix ist hier leer, da die
                // Tabelle beim Erzeugen noch nicht im tableContainer haengt -> data-cy = "day:<ISO>"
                this.setDataCyAttribute(calendarDayContainer, "day:" + currentDateTxt);

                if (todayShort == currentDateTxt) {
                    this.UiModder.domClass.toggle(calendarDayContainer, "today", true);
                }

                this.UiModder.domClass.toggle(calendarDayContainer, "weekend", i >= 5 && i <= 6);

                if (this.currentSelect[currentDateTxt] == currentDateTxt) {
                    this.UiModder.domClass.toggle(calendarDayContainer, "selected", true);

                    this.UiModder.domClass.toggle(calendarDayContainer, "selectable", this.enableUnselect);
                }


                currentDate.setDate(currentDate.getDate() + 1);
            }

            if (currentDate.getMonth() != targetDate.getMonth()) {

                this.visibleLastDate = new Date(currentDate.setSeconds(currentDate.getSeconds() - 1));
                break;
            }
        }
        this.UiModder.domConstruct.place(table, this.tableContainer, "only");

        let appts = this.knownAppointments;
        this.knownAppointments = [];
        for (let data of appts) {
            this.addAppointmentIcon(data.date, data.iconOrNode, data.groupValue, data.title, data.clickFct, data.colorationHex);
        }

        for (let data of knownHolidays) {
            this.addHoliday(data.date, data.icon, data.title, data.hexColorBG, data.hexColorTXT, data.content);
        }

        return targetDate;
    }

    toggle(): void {
        if (this._showState) {
            this.hide();
        } else {
            this.show();
        }
    }

    show(): void {
        if (this._showState == false) {
            this._showState = true;
            this.UiModder.domStyle.set(this.domNode, "display", "block");
        }
    }

    hide(): void {
        if (this._showState == true) {
            this._showState = false;
            this.UiModder.domStyle.set(this.domNode, "display", "none");
        }
    }

    toggleYearSelect(e?: Event): void {
        let bIsMonthSelectShown = this.monthSelectPopup.classList.contains("show");
        let bIsYearSelectShown = this.yearSelectPopup.classList.contains("show");

        if (bIsMonthSelectShown && !bIsYearSelectShown) this.toggleMonthSelect();

        this.UiModder.domClass.toggle(this.yearSelectPopup, "show");
        this.UiModder.domClass.toggle(this.yearSelectButton, "show");

        if (typeof (e) != "undefined")
            e.stopPropagation();
    }

    toggleMonthSelect(e?: Event): void {
        let bIsMonthSelectShown = this.monthSelectPopup.classList.contains("show");
        let bIsYearSelectShown = this.yearSelectPopup.classList.contains("show");

        if (bIsYearSelectShown && !bIsMonthSelectShown) this.toggleYearSelect();

        this.UiModder.domClass.toggle(this.monthSelectButton, "show");
        this.UiModder.domClass.toggle(this.monthSelectPopup, "show");

        if (typeof (e) != "undefined")
            e.stopPropagation();
    }
    
    private knownAppointments: Array<DatePickerAppointmentData> = [];
    emptyAppointments(): void {
        for (let key in this.nodeList) {
            let reg = this.nodeList[key];

            let container = reg?.iconContainer;
            if (container && container.icons && container.icons.length) {
                if (container.node) {
                    this.UiModder.domConstruct.empty(container.node);
                    container.icons = [];
                }
            }

            if (reg.holidays) {
                for (let holiday of reg.holidays) {
                    if (holiday.node) {
                        this.UiModder.domConstruct.destroy(holiday.node);
                    }
                }

                reg.holidays = [];
            }
        }
        this.knownAppointments = [];
       
    }
    /**
     * Fügt ein Icon an ein 
     * @param iconNodeOrClass Entweder fa-Iconklasse (und Styleklasse)
     * @param date Datum, an dem das Icon platziert wird. Befindet sich das Datum außerhalb des gezeigten Monats, wird kein Icon eingefügt
     * @param  groupValue ein beliebiger Wert, nachdem "gleichartige" Elemente pro Kalendertag erkannt werden. Es wird dann von jeder Gruppe maximal 1 Element platziert.
     * @param  clickFct Callback das bei Klick ausgelöst wird. Achtung: Bei ausgefüllter Groupvalue gibt es nur ein Icon pro Grup.
     * */
    addAppointmentIcon(date: Date,
        iconNodeOrClass: HTMLElement | string,
        groupValue?: string,
        title?: string,
        clickFct?: Function,
        colorationHex?: string    ) {
        if (!(date instanceof Date) || !iconNodeOrClass) {
            return;
        }
        let dateKeyString = this.getShortDate(date);

        let reg = this.nodeList[dateKeyString];

        let container: DatePickerIconContainer = reg?.iconContainer;

        if (!container) return;


        this.knownAppointments.push({
            groupValue: groupValue,
            iconOrNode: iconNodeOrClass,
            date: date,
            title: title,
            clickFct: clickFct,
            colorationHex: colorationHex
        });

        let foundGroup = false;
        let existingIcon: DatePickerIconEntry = null;
        let groupCounter = 1;
        if (container.icons) {
            if (groupValue && this.showAppointmentLabels != true) {
                for (let icon of container.icons) {
                    if (icon.groupValue == groupValue && groupValue) {
                        existingIcon = icon;
                        foundGroup = true;
                        break;
                    }
                }
            }
        } else {
            container.icons = [];
        }

        //if (foundGroup) return;
        let node = null;
        let tooltipContent: string = null;

        if (!foundGroup) {
            node = this.UiModder.domConstruct.create("div", {
                className: "appointmentIconContainer"
            }, container.node);
           
            if (typeof (iconNodeOrClass) == "string") {
                let icon = this.createFontawesomeIcon(iconNodeOrClass, "", node);

                if (!colorationHex) {
                    // ist die Färbung vielleicht in der class dabei? zb w3-text-orange
                    let css = window.getComputedStyle(icon);
                    if (css.color) {
                        colorationHex = css.color;// ColorHelpers.getHexColorFromString(css.color);
                    } else if (css.backgroundColor) {
                        colorationHex = css.backgroundColor;// ColorHelpers.getHexColorFromString(css.backgroundColor);
                    }
                }

                if (colorationHex) {
                    //ColorHelpers.colorNode(icon, null, colorationHex);
                    //this.UiModder.domStyle.set(icon, "color", colorationHex);
                    icon.style.setProperty("--color", colorationHex);
                    this.UiModder.domClass.add(icon, "colored");
                } else {
                    this.UiModder.domClass.add(icon, "noColor");
                }
            } else {
                this.UiModder.domConstruct.place(iconNodeOrClass, node);
            }

            existingIcon = {
                groupValue: groupValue,
                count: 1,
                description: title,
                node: node,
                shortDate: dateKeyString,
                labelNode: null
            };

            if (this.showAppointmentLabels == true) {
                let label = this.UiModder.domConstruct.create("label", {
                    innerHTML: title,
                    class: "appointmentLabel"
                }, node);

                existingIcon.labelNode = label;
            }

            tooltipContent = title;

            container.icons.push(existingIcon);

            this.UiModder.domConstruct.place(node, container.node);


        } else {
            node = existingIcon.node;

            if (existingIcon.count == 1) {
                existingIcon.description = [existingIcon.description as string];
            }
            if (title) {
                (existingIcon.description as Array<string>).push(title);
            } else {
                (existingIcon.description as Array<string>).push("");
            }

            existingIcon.count++;
            existingIcon.node.setAttribute("entryCount", existingIcon.count <= 9 ? existingIcon.count.toString() : "+");

        }

        let maxTooltipCount = 5;

        let tooltip: MdsLax<InstanceType<typeof Tooltip>> = null;
        if (existingIcon.tooltipWidget) {
            tooltip = existingIcon.tooltipWidget;

            tooltipContent = (existingIcon.description as Array<string>).join("<br>");

            if (existingIcon.count > maxTooltipCount) {
                tooltipContent = (existingIcon.description as Array<string>).slice(0, maxTooltipCount).join("<br>");
                tooltipContent += "<br>" + this.UiModder.domConstruct.create("span", { className: "w3-opacity", innerHTML: "+" + (existingIcon.count - maxTooltipCount).toString() }).outerHTML;
            } else {
                tooltipContent = (existingIcon.description as Array<string>).join("<br>");
            }

            let smallerContent = this.UiModder.domConstruct.create("span", {
                className: "w3-small",
                innerHTML: tooltipContent
            });

            tooltip.setContent(smallerContent);
            //tooltip.setHeading(existingIcon.count.toString());
            this.UiModder.domClass.add(existingIcon.node, "multiple");
        } else {
            tooltip = new Tooltip();
            tooltip.setup({
                content: tooltipContent,
                targetnode: node,
                icon: typeof iconNodeOrClass == "string" ? iconNodeOrClass : iconNodeOrClass.className,
                delayMS: 400
            });

            existingIcon.tooltipWidget = tooltip;
        }


        return node;
    }
    addHoliday(date: Date,
        iconClass: string,
        title: string,
        hexColorBG?: string,
        hexColorTXT?: string,
        content?: string | HTMLElement
    ) {

        if (!(date instanceof Date) || !iconClass) {
            return;
        }
        let dateKeyString = this.getShortDate(date);
        let dateReg = this.nodeList[dateKeyString];

        if (!dateReg) return;

        let holidaysOfDate = dateReg.holidays;

        if (!holidaysOfDate) {
            holidaysOfDate = [];
            dateReg.holidays = holidaysOfDate;
        }


        let node: HTMLElement;

        // nur den ersten Feiertag hinzeichnen!
        if (!holidaysOfDate.length) {
            node = this.UiModder.domConstruct.create("div", {
                className: "holiday hoverDark"
            }, dateReg.dayLabelNode);

            
            let icon = this.createFontawesomeIcon("fas fa-umbrella-beach", null, node);
            //let icon = this.createFontawesomeIcon("fas fa-mug-hot", null, node);

            //let label = this.UiModder.domConstruct.create("span", {
            //    className: "holidayLabel",
            //    innerHTML: title,

            //}, node);

            

            on(node, "click", lang.hitch(this, this._createHolidayTooltip, dateKeyString, node));
        
            
        }

        holidaysOfDate.push({
            date: date,
            node: node,
            icon: iconClass,
            title: title,
            content: content,
            hexColorBG: hexColorBG,
            hexColorTXT: hexColorTXT
        });
    }

    private _createHolidayTooltip(dateKey: string, targetNode: HTMLElement, evt: MouseEvent) {

        let reg = this.nodeList[dateKey];


        evt.preventDefault();
        evt.stopPropagation();

        let content: HTMLElement = this.UiModder.domConstruct.create("div", {
            className: "holidayTooltip"
        });

        for (let holiday of reg.holidays) {
            let container = this.UiModder.domConstruct.create("div", {
                className: "holidayEntry",
            }, content);

            let hexColorBG = holiday.hexColorBG;
            let hexColorTXT = holiday.hexColorTXT;

            if (hexColorBG) container.style.setProperty("--holidayBG", hexColorBG);

            if (!hexColorTXT && hexColorBG) {
                let isDark = ColorHelpers.isDarkColor(hexColorBG);
                if (isDark) {
                    this.UiModder.domClass.add(container, "darkBG");
                }
            } else if (hexColorTXT) {
                container.style.setProperty("--holidayTXT", hexColorTXT);
            }


            let label = this.UiModder.domConstruct.create("p", {
                className: "holidayLabel",
                innerHTML: holiday.title
            }, container);

            if (holiday.icon) {
                HtmlHelpers.createFontawesomeIcon(holiday.icon, "right", label);
            }

            if (holiday.content) {
                
                let anyContent = this.UiModder.domConstruct.create("div", {
                    className: "holidayContent",
                    innerHTML: holiday.content
                }, container);

                if (anyContent.childNodes.length || typeof (holiday.content) == "object") {
                    if (holiday.content instanceof HTMLElement) {
                        this.UiModder.domConstruct.place(holiday.content, anyContent, "only");
                    }
                    this.UiModder.domClass.add(anyContent, "htmlContent");
                }
            }
        }

        let floating = new FloatingContainer();
        //floating.openSimple({
        //    evtSource: evt,
        //    alternativeTarget: targetNode,
        //    content: content,
        //    zIndex: 100
        //});
        floating.open(evt, content);
    }

    getDocumentationContent(): string {
        return docu;
    }

    private _onGlobalClick(evt) {
        this._closeDropwdowns();
    }


    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.nodeList = {};
        this.knownAppointments = [];
        //this.iconContainers = new Array<any>();
        this.currentSelect = [];
        this._drawCalendar(new Date());

        this.addSubscription("/Global/Click", lang.hitch(this, this._onGlobalClick));

    }
     /**
      * 
      * @param navigationDate Datum (Tag eines Monats), zu dem geblättert wird (aktueller Monat oder frühest- bzw. spätestmöglicher Monat)
      * @param preselectedDate Vorausgewählter Kalendertag oder null wenn keine Auswahl
      * @param earliestDate Frühestes auswählbares Datum
      * @param latestDate Spätestes auswählbares Datum
      * @param selectMode Einzel- oder Mehrfachauswahl. "none" erlaubt keine Auswahl, das Control dient nur zum Blättern.
      */
    setup(navigationDate: Date,
        preselectedDate: Date,
        earliestDate: Date,
        latestDate: Date,
        selectMode: "singleSelect" | "multiselect" | "none" | "agendaNavigation" | "agendaWithLabels"
    ): void {

        this.enableSelect = selectMode != "none";
        this.isMultiSelect = selectMode == "multiselect";
        this.enableUnselect = selectMode == "agendaNavigation" || selectMode == "agendaWithLabels" || this.isMultiSelect;
        this.displayAppointmentIcons = selectMode == "agendaNavigation" || selectMode == "agendaWithLabels";
        this.UiModder.domClass.toggle(this.domNode, "agendamode", this.displayAppointmentIcons);

        this.showAppointmentLabels = this.displayAppointmentIcons && selectMode == "agendaWithLabels";

        

        if (earliestDate) {
            this.earliestDate = new Date(earliestDate.getFullYear(), earliestDate.getMonth(), earliestDate.getDate(), 0, 0, 0, 0);
            let earlyTxt = this.earliestDate.toString();
        }
        if (latestDate) {
            this.latestDate = new Date(latestDate.getFullYear(), latestDate.getMonth(), latestDate.getDate(), 0, 0, 0, 0);
            let lateTxt = this.latestDate.toString();
        }
        let now = new Date();

        let targetDate = navigationDate;
        if (navigationDate == null) targetDate = now;

        if (this.earliestDate != null && now.getTime() < this.earliestDate.getTime()) {
            targetDate = this.earliestDate;
        } else if (this.latestDate != null && now.getTime() > this.latestDate.getTime()) {
            targetDate = this.latestDate;
        }
        
        this._drawCalendar(targetDate);

        if (preselectedDate == null) this.removeCurrentSelect();
        else if (preselectedDate instanceof Date) {
            this.toggleDateSelect(preselectedDate);
        }


    }

    setupStyles(baseFontSize: string = "1rem",
        calendarFontSize: string = "0.9em",
        popupFontSize: string = "0.9em",
        baseSizeUnit: string = "32px",
        //menuHeightFactor: number = 1.2,
        calendarHeightFactor: number = 1,
        calendarWidthFactor: number = 1.1) {

        if (baseFontSize) {
            this.domNode.style.setProperty("--baseFontSize", baseFontSize);
        }

        if (popupFontSize) {
            this.domNode.style.setProperty("--popupFontSize", popupFontSize );
        }

        if (calendarFontSize) {
            this.domNode.style.setProperty("--calendarFontSize", calendarFontSize);
        }

        if (baseSizeUnit) {
            this.domNode.style.setProperty("--baseSizeUnit", baseSizeUnit);
        }

        if (calendarHeightFactor) {
            this.domNode.style.setProperty("--heightFactor", calendarHeightFactor.toString());
        }

        if (calendarWidthFactor) {
            this.domNode.style.setProperty("--widthFactor", calendarWidthFactor.toString());

        }
    }


    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DatePicker);
